import { makeStyles } from '@material-ui/core/styles'

export const useTableStyles = makeStyles({
  root: {
    width: '100% !important',
  },
  paper: {
    width: '100% !important',
    // transform required to make toolbar width match parent
    transform: 'translate(0, 0) !important'
  },
  tabs: {
    position: 'absolute !important',
    flexDirection: 'row !important'
  }
})
